/**
 * Click-outside-to-dismiss handlers for a modal backdrop.
 *
 * A bare `onClick` on the backdrop also fires when a click *starts* inside the
 * modal and finishes outside it -- which is what happens whenever someone selects
 * text in a field and releases the mouse past the edge of the dialog. The modal
 * then closes and any unsaved edits are lost.
 *
 * These handlers only dismiss when both the press and the release landed on the
 * backdrop itself, so dragging out of a form no longer closes it.
 *
 * The flag lives at module scope rather than inside the closure because React may
 * re-render between mousedown and click, which would discard a closure-local one.
 * Only one backdrop can be under the pointer at a time, so a single flag is safe.
 *
 * Usage:
 *   <div className="modal-overlay" {...overlayDismiss(() => setModal(null))}>
 *     <div className="modal">...</div>
 *   </div>
 */
let pressedBackdrop = false;

export const overlayDismiss = (onClose) => ({
  onMouseDown: (e) => {
    pressedBackdrop = e.target === e.currentTarget;
  },
  onClick: (e) => {
    const shouldClose = pressedBackdrop && e.target === e.currentTarget;
    pressedBackdrop = false;
    if (shouldClose) onClose();
  }
});

export default overlayDismiss;
